import { PureComponent } from "react";
import { MenuItem, Modal, ValidatedInput } from "../../components";
import { connect, DispatchProp } from "react-redux";
import React from "react";
import { LiteralsService } from "../../services";
import StyledDiv from './styles'
import { setToggleCountryPickerModalAction } from "../../store/actions";
import { ICountry } from "../../models/country";
import countries from '../../countries.json';
import { images } from "../../images";
import theme from '../../theme'
import { IStoreState } from "../../store/states";

interface IProps extends DispatchProp<any> {
  isCountryPickerModalOpen: boolean,
  selectedCountry: ICountry,
  selectCountry: (country: ICountry) => void
}

interface IState {
  searchValue: string
  countriesList: any[]
}

class CountryPickerModal extends PureComponent<IProps, IState> {
  private get modalContent() {
    const { selectCountry, selectedCountry } = this.props
    const { countriesList } = this.state
    return (
      <div className="content">
        {
          countriesList.map((country: ICountry, index) => {
            return <MenuItem
              key={country.code}
              label={`${country.emoji} ${country.name}`}
              code={country.dial_code}
              onClick={ () =>  this.handleCountryClick(country) }
              icon={ selectedCountry?.code === country.code ? 'checkLanguage' : undefined }
            ></MenuItem>
          })
        }
      </div>
    )
  }

  constructor(props: IProps) {
    super(props)
    this.state = {
      searchValue: '',
      countriesList: countries
    } 
  }

  public render() {
    const { isCountryPickerModalOpen } = this.props
    const { searchValue } = this.state
    
    if (!isCountryPickerModalOpen) return null
    return (
      <Modal isHidden={ false } onOverlayClick={ this.handleClose }>
        <StyledDiv>
          <header>
            <div className="search-container">
              <div className='search-icon'>
                <img src={ images['lens'] } alt='search' />
              </div>
              <ValidatedInput 
                label=''
                name='searchInput'
                value={searchValue}
                onChange={ this.handleSearchChange }
                containerStyles={{
                  margin: '0'
                }}
                styles={{
                  borderBottom: 'none',
                  paddingLeft: '40px',
                  border: `solid 1px ${theme.colors.grey}`,
                  borderRadius: '4px'
                }}
                placeholder={ LiteralsService.get('search', true) }
              />
            </div>
            <div className="close-container" onClick={ () => this.handleClose() }>
              <img src={ images['cross'] } alt='cross' />
            </div>
          </header>
          { this.modalContent }
        </StyledDiv>
      </Modal>
    )
  }

  private handleSearchChange = (value: string) => {
    this.setState({ 
      searchValue: value,
      countriesList: countries.filter(country => country.name.toLowerCase().includes(value.toLowerCase()))
    })
  }

  private handleCountryClick = (country: ICountry) => {
    const { selectCountry } = this.props
    this.handleClose()
    selectCountry(country)
  }

  private handleClose = () => {
    const { dispatch } = this.props
    this.setState({ 
      searchValue: '',
      countriesList: countries
    })
    dispatch(setToggleCountryPickerModalAction())
  }

}

const mapStateToProps = ({ signUp }: IStoreState) => ({
  selectedCountry: signUp.country,
  isCountryPickerModalOpen: signUp.isCountryPickerModalOpen
})

export default connect(mapStateToProps)(CountryPickerModal)